import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=31febdd3"
import script from "./Notify.vue?vue&type=script&lang=js"
export * from "./Notify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports